import React from "react";
import { useLocation } from "react-router-dom";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    const [controller, dispatch] = useMaterialUIController();
    const { user } = controller;
    const { pathname } = useLocation();
    const pathnameCopy = pathname.replace(/^\/+/g, '');
    let includeMenu = true;
    if(typeof(pathnameCopy) === "string" && pathnameCopy.split("/")[0] === "admin"){
        includeMenu = false;
    }
    let menus = [];
    if(user === null || !user.superAdmin){
        return menus;
    }
    if(includeMenu){
        menus.push({
            type: "menu_item",
            name: "Admin",
            key: "admin",
            icon: <Icon fontSize="medium">admin_panel_settings_outlined</Icon>,
            route: "/admin",
            privacy: "private",
        });
    }
    return menus;
};

export default menus;